import MonthEndPortal from '../../../shared/MonthEndPortal';
import { getAuthToken } from '../services/authSession';
export default function MonthEndPage(){return <MonthEndPortal token={getAuthToken()} base={import.meta.env.VITE_API_BASE_URL||''}/>;}
